import store from './store';
import permissions from './permissions';
import Vue from 'vue';

Vue.mixin({
  methods: {
    can: function(permission) {
      // If authenticated, redirect to account page
      if (store.getters['user/initializing']) {
                
        store.watch((state) => state.user.initializing, (initializing) => {
                    
          if (!initializing) {
            return permissions.can(permission);        
          }
        });

      } else {
        return permissions.can(permission);
      }
    }
  }
});